import { routes } from 'configs/routes';
import { useLayout } from 'contexts/LayoutProvider';
import React, { ReactElement, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Route, useLocation, Switch } from 'react-router-dom';
import { configManager, isProdEnvironment } from 'utils/configuration';
import { PropsWithOptionalChildren } from '../../types/common';

type LocationState = { background: boolean };

export function RouterMapper(): ReactElement {
  const loc = useLocation<LocationState>();
  const background = loc.state?.background;

  const getConfig = configManager.getInstance().get;

  const cdnBucketFullUrl = `${getConfig('CDN_URL')}${getConfig('BUCKET_PATH')}`;

  return (
    <>
      <Switch>
        {Object.values(routes).map(
          ({ key, title, path, exact, options, component: Component }) => (
            <Route key={key} exact={exact} path={path}>
              <Helmet>
                {title && <title>{title}</title>}

                <link
                  rel="stylesheet"
                  href={getConfig('ICONS_URL') as string}
                />

                {isProdEnvironment() && (
                  <script async src={`${cdnBucketFullUrl}/scripts/gtm.js`} />
                )}
              </Helmet>
              <HeaderWrapper
                title={title}
                shouldChangeTitle={options.changeTitle}>
                <Component />
              </HeaderWrapper>
            </Route>
          )
        )}
      </Switch>
      {background && <Route />}
    </>
  );
}

type HeaderWrapperProps = PropsWithOptionalChildren<{
  title?: string;
  shouldChangeTitle?: boolean;
}>;

export const HeaderWrapper: React.FC<HeaderWrapperProps> = ({
  title,
  children,
  shouldChangeTitle = true,
}: HeaderWrapperProps): ReactElement => {
  const { changeTitle } = useLayout();

  useEffect(() => {
    shouldChangeTitle && changeTitle(title);
  }, []);

  return <>{children}</>;
};
